import { Component, HostListener, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { DuprService } from '../dupr.service';
import { LocalStorage } from '@core/localstorage';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dupr-premium-modal',
    templateUrl: './dupr-premium-modal.component.html',
    styleUrls: ['./dupr-premium-modal.component.scss'],
})
export class DuprPremiumModalComponent implements OnInit {
    loading: boolean = false;
    urlDupr: string = '';

    redirectRoute: string;

    constructor(
        private dialogRef: NbDialogRef<DuprPremiumModalComponent>,
        private DUPRService: DuprService,
        private localStorage: LocalStorage,
        private nbToastrService: NbToastrService
    ) { }

    ngOnInit(): void {
        this.urlDupr = `${environment.urlDupr}premium-login?clientKey=${btoa(environment.clientKeyDupr)}`;
    }

    @HostListener('window:message', ['$event'])
    onExternalLoginMessage(event: MessageEvent) {
        const payload: any = event.data || {};

        const { subscriptions } = payload;

        if (subscriptions) {
            const currentUser = this.localStorage.getUser();

            this.localStorage.saveUser({ ...currentUser, dupr_subscriptions: subscriptions });

            window.dispatchEvent(new Event('duprPremiumSyncComplete', { bubbles: true }));
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
